export default {
  twitter: require('./twitter'),
  facebook: require('./facebook'),
  logo: require('./logo'),
  circle: require('./circle'),
  external: require('./external'),
}



// WEBPACK FOOTER //
// /opt/build/repo/src/components/Icon/paths/index.js